module.exports = __webpack_public_path__ + "static/media/han_cha_saw_ppe.73c658b7.png";